
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyCanWest as ObiBuoyCanWestElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-can-west.js';
 
 
 

 
 export const ObiBuoyCanWest = createComponent({
   react: React,
   tagName: 'obi-buoy-can-west',
   elementClass: ObiBuoyCanWestElement,
   events: {
     
   }
  });
 
 